import React, {Fragment} from 'react';
import {Image} from 'react-bulma-components';
import Button from '../button';
import {Animated} from 'react-animated-css';

export default (props) => {
  return (
    <Fragment>
      <div style={styles.wrapper}>
        <div style={styles.leftColumn}>
          <Animated
            animationIn="fadeInLeft"
            animationInDuration={500}
            animationInDelay={100}
            animateOnMount={true}>
            <h2 style={styles.h2}>Pathfinder Bridge</h2>
          </Animated>
          <Animated
            animationIn="fadeInLeft"
            animationInDuration={500}
            animationInDelay={200}
            animateOnMount={true}>
            <p style={styles.body}>
              Bridge is a web based dashboard for Administrators and Counselors
              to view shared data, and communicate with their clients.
            </p>
          </Animated>
          <Animated
            animationIn="fadeIn"
            animationInDuration={500}
            animationInDelay={1500}
            animateOnMount={true}>
            <Button id="nextButton" data-testid="start-tutorial-button">
              Companion
            </Button>
          </Animated>
        </div>
        <div style={styles.rightColumn}>
          <Animated
            animationIn="fadeIn"
            animationInDuration={500}
            animationInDelay={400}
            animateOnMount={true}>
            <Image
              renderAs="p"
              style={styles.image}
              src={
                'https://storage.googleapis.com/pf-bucket-default-prod/tutorial/computer_w_logo.png'
              }
            />
          </Animated>
        </div>
      </div>
      <Button
        id="tutorialSkipButton"
        className={'tutorialSkipButton'}
        data-testid="skip-tutorial-button">
        Skip Tutorial
      </Button>
    </Fragment>
  );
};

const styles = {
  h2: {
    fontSize: 26,
    fontWeight: 700,
    marginBottom: '25px',
    color: '#ffffff',
  },
  body: {
    marginBottom: 20,
    fontWeight: 500,
    fontSize: 18,
  },
  wrapper: {
    width: '90vw',
    display: 'flex',
    height: 'calc(100% - 56px)',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#d6d6d6',
    margin: '0 auto',
  },
  image: {
    maxWidth: 1200,
    margin: '0 auto',
    width: '75%',
  },
  group: {
    height: '100%',
  },
  leftColumn: {
    width: '30vw',
    marginRight: '10vw',
  },
  rightColumn: {
    width: '60vw',
  },
};
